// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c87c80c7f347f1b43a09","655":"7d3c763c4a688694bdc2"}[chunkId] + ".js";
};